import React from 'react'
import TmoInput from './TmoInput'

function TmoNumberInput({ onChange, ...props }) {
  const handleInputChange = (newValue) => {
    const numericValue = newValue.replace(/\D/g, '')
    onChange(numericValue)
  }

  return (
    <TmoInput
      type='text'
      pattern='[0-9]*'
      inputmode='numeric'
      onChange={handleInputChange}
      {...props}
    />
  )
}

export default TmoNumberInput
